import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { environment } from './environments/environment';
import { BrowserDetectorService, EcaComponentsLibModule, EcaHeaderModule, EcaFooterModule, EcaIconModule, EcaAccessDeniedModule, SkipToContentButtonModule, EcaAppShellModule, OKTA_CONFIG } from '@drc-eca/eca-components-lib';
import { DeviceDetectorService } from 'ngx-device-detector';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { CommonModule } from '@angular/common';
import { provideAnimations } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app/app-routing.module';
import { CoreModule } from './app/core/core.module';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';

if (environment.production) {
  enableProdMode();
}

const localOktaClientConfig = window.location.hostname === 'localhost'
  ? {
      redirectUri: `${window.location.origin}/login/callback`,
      tokenManager: { secure: false }
    }
  : undefined;

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),
        importProvidersFrom(EcaComponentsLibModule.forRoot(environment.apiGatewayConfig), FlexLayoutModule, CommonModule, FormsModule, ReactiveFormsModule, EcaHeaderModule, EcaFooterModule, EcaIconModule, AppRoutingModule, CoreModule, EcaAccessDeniedModule, SkipToContentButtonModule, EcaAppShellModule),
        {
          provide: OKTA_CONFIG,
          useValue: {
            clientConfig: localOktaClientConfig,
            scopes: ['profile', 'okta.myAccount.password.read', 'okta.myAccount.password.manage']
          }
        },
        { provide: BrowserDetectorService, useClass: DeviceDetectorService },
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations()
    ]
})
  .catch(err => console.log(err));
